import { render, staticRenderFns } from "./ScriptDetail.vue?vue&type=template&id=5bfb4e9e&scoped=true&"
import script from "./ScriptDetail.vue?vue&type=script&lang=js&"
export * from "./ScriptDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScriptDetail.vue?vue&type=style&index=0&id=5bfb4e9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb4e9e",
  null
  
)

export default component.exports